import {
	type Chat,
	isStreamResponse,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Finds the persisted execution result for an action invocation in a fetched chat history.
 *
 * Matches on `invocationId` alone — it is unique to the invocation, so this does not depend on the
 * caller holding the right message id. Returns `undefined` when the action is absent or the backend
 * wrote no result for it, which is also the case when the tool itself failed.
 */
export const getExecutedDataFromChat = (chat: Chat, invocationId: string): unknown => {
	for (const item of chat) {
		if (!isStreamResponse(item)) {
			continue;
		}

		const action = item.message?.message?.actions?.find(
			(candidate) => candidate.invocationId === invocationId,
		);

		if (action?.executedData !== undefined) {
			return action.executedData;
		}
	}

	return undefined;
};
